<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>
    </div>
</template>


<script>
import amplitude from '../util/analytics/amplitude';

const HELP_ARTICLE_LINKS_CLASSIC = [
    {
        id: 1,
        link: 'https://learn.thryv.com/hc/en-us/articles/37278892828429-Email-Bounces-Explained-with-Keap',
        label: 'Email Bounces Explained',
    },
    {
        id: 2,
        link: 'https://learn.thryv.com/hc/en-us/articles/41636371667853-Email-Reputation-Essentials-with-Keap',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://learn.thryv.com/hc/en-us/articles/37026226668813-List-Hygiene-with-Keap',
        label: 'Review List Hygiene',
    },
    {
        id: 4,
        link: 'https://learn.thryv.com/hc/en-us/articles/37443318628621-How-to-Avoid-Content-Filters-In-Email-Marketing-with-Keap',
        label: 'Check your Content and Subject Line',
    },
    {
        id: 5,
        link: 'https://learn.thryv.com/hc/en-us/articles/41630277888013-Automated-List-Management-with-Keap',
        label: 'Set Automated List Management',
    },
];

const HELP_ARTICLE_LINKS_KEAP = [
    {
        id: 1,
        link: 'https://learn.thryv.com/hc/en-us/articles/37278892828429-Email-Bounces-Explained-with-Keap',
        label: 'Email Bounces Explained',
    },
    {
        id: 2,
        link: 'https://learn.thryv.com/hc/en-us/articles/41636371667853-Email-Reputation-Essentials-with-Keap',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://learn.thryv.com/hc/en-us/articles/37026226668813-List-Hygiene-with-Keap',
        label: 'Review List Hygiene',
    },
    {
        id: 4,
        link: 'https://learn.thryv.com/hc/en-us/articles/37443318628621-How-to-Avoid-Content-Filters-In-Email-Marketing-with-Keap',
        label: 'Check your Content and Subject Line',
    },
];

export default {
    props: {
        isUpdateHelpArticleLinksEnabled: {
            type: Boolean,
            default: false,
        },
        isUnengagedEmailStatusProcessingEnabled: Boolean,
        appEdition: String,
    },
    computed: {
        icon() {
            return 'circle';
        },
        showSetListManagementCallToAction() {
            return Boolean(this.isUnengagedEmailStatusProcessingEnabled);
        },
        listItems() {
            const isClassic = this.appEdition === 'Keap Max Classic Edition';

            if (isClassic) {
                return HELP_ARTICLE_LINKS_CLASSIC;
            }

            return HELP_ARTICLE_LINKS_KEAP;
        },
    },

    methods: {
        handleClick(object) {
            window.open(object.link, '_blank');

            this.emitAmplitudeEvent(object.label);
        },
        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Bounce Page',
                Destination: event,
            });
        },
    },
};

</script>

<style lang="scss" scoped>

#leadingSlot {
    padding: 0;
}

.list-item-description {
    font-size: $font-size-md;
    padding-right: $spacing-200;
}

.row {
    display: flex;
}

.column-left {
    flex: 50%;
    float: left;
}

.column-right {
    flex: 50%;
    text-align: right;
}

</style>
